/* Prices and applicability come exclusively from Shopify's Ajax Cart API.
   The theme's merge updates item keys, totals and the free-delivery threshold. */
(function () {
  if (customElements.get('sl-cart-discount')) return;
  var busy = false;
  var mergingCart = null;
  var root = window.Shopify.routes.root;
  function normal(code) { return String(code).toLocaleUpperCase(); }
  function applications(cart) {
    return (cart.cart_level_discount_applications || []).map(function (a) {
      return { app: a.discount_application || a, amount: a.amount == null ? a.total_allocated_amount : a.amount };
    }).concat((cart.items || []).flatMap(function (item) {
      return (item.line_level_discount_allocations || []).map(function (a) {
        return { app: a.discount_application, amount: a.amount };
      });
    }));
  }
  function codes(cart) {
    if (Array.isArray(cart.discount_codes)) return cart.discount_codes;
    return applications(cart).filter(function (a) { return a.app.type === 'discount_code'; })
      .map(function (a) { return { code: a.app.title, applicable: true }; })
      .filter(function (a, i, all) { return all.findIndex(function (b) { return normal(a.code) === normal(b.code); }) === i; });
  }
  async function api(path, data) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 15000);
    try {
      var response = await fetch(root + path, {
        method: data ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: data ? JSON.stringify(data) : undefined, signal: controller.signal
      });
      if (!response.ok) throw new Error('Cart request failed: ' + response.status);
      return await response.json();
    } finally { clearTimeout(timer); }
  }
  function money(amount, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'pl', { style: 'currency', currency: currency }).format(amount / 100);
  }
  function current(form) { return form.querySelector('sl-cart-discount'); }
  async function merge(cart, form, sectionId) {
    var html = cart.sections && cart.sections[sectionId];
    if (!html) {
      var sections = await api('?sections=' + encodeURIComponent(sectionId));
      html = sections[sectionId];
    }
    if (!html) throw new Error('Missing cart section');
    var holder = document.createElement('div');
    holder.innerHTML = html;
    if (!holder.querySelector('cart-form [data-merge="footer"], cart-form [data-merge="total"]')) throw new Error('Invalid cart section');
    mergingCart = cart;
    try { window.theme.mergeNodes(holder, form); } finally { mergingCart = null; }
    form.removeAttribute('data-sld-uncertain');
    // Keep the header counter in sync without starting a second cart refresh.
    document.querySelectorAll('.cart-link__count').forEach(function (el) { el.textContent = cart.item_count; });
  }
  class SLCartDiscount extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-sld-input]');
      this.panel = this.querySelector('.sld__panel');
      this.message = this.querySelector('[data-sld-message]');
      this.addEventListener('click', this.onClick.bind(this));
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); this.apply(); }
      });
      this.input.addEventListener('input', () => {
        this.input.removeAttribute('aria-invalid'); this.say('');
      });
      if (mergingCart) this.render(mergingCart);
      else api('cart.js').then((cart) => { if (this.isConnected && !busy) this.render(cart); }).catch(function () {});
    }
    focusInput() {
      this.input.focus({ preventScroll: true });
      // Reveal the field only inside the list, never by scrolling modal ancestors.
      var content = this.closest('.cart-drawer__content');
      if (!content) return;
      var field = this.panel.getBoundingClientRect();
      var bounds = content.getBoundingClientRect();
      if (field.bottom > bounds.bottom - 12) content.scrollTop += field.bottom - bounds.bottom + 12;
      else if (field.top < bounds.top + 12) content.scrollTop -= bounds.top + 12 - field.top;
    }
    say(text, error) {
      this.message.textContent = text;
      this.message.classList.toggle('is-error', !!error);
    }
    render(cart) {
      var list = this.querySelector('[data-sld-codes]');
      list.replaceChildren();
      var all = applications(cart);
      codes(cart).forEach(function (discount) {
        var row = document.createElement('li'); row.className = 'sld__code';
        var title = document.createElement('span'); title.className = 'sld__code-name'; title.textContent = discount.code;
        var amount = all.filter(function (a) { return a.app.type === 'discount_code' && normal(a.app.title) === normal(discount.code); })
          .reduce(function (sum, a) { return sum + Number(a.amount || 0); }, 0);
        var value = document.createElement('span'); value.className = 'sld__amount';
        value.textContent = discount.applicable && amount > 0 ? '−' + money(amount, cart.currency) : (discount.applicable ? 'Kod przyjęty' : 'Nieaktywny dla tego koszyka');
        if (!discount.applicable) row.classList.add('is-inactive');
        var remove = document.createElement('button'); remove.type = 'button'; remove.className = 'sld__remove';
        remove.dataset.sldRemove = discount.code; remove.setAttribute('aria-label', 'Usuń kod ' + discount.code); remove.textContent = '×';
        row.append(title, value, remove); list.append(row);
      });
      list.hidden = !list.children.length;
    }
    onClick(e) {
      if (e.target.closest('[data-sld-apply]')) this.apply();
      var remove = e.target.closest('[data-sld-remove]');
      if (remove) this.change(remove.dataset.sldRemove, true);
      if (e.target.closest('[data-sld-retry]')) window.location.reload();
    }
    apply() {
      var code = this.input.value.trim();
      if (!code || code.includes(',')) {
        this.say(code ? 'Wpisz jeden kod rabatowy naraz.' : 'Wpisz kod rabatowy.', true);
        this.input.setAttribute('aria-invalid', 'true'); this.focusInput(); return;
      }
      this.change(code, false);
    }
    async change(code, removing) {
      var form = this.closest('cart-form');
      if (busy) return;
      var quantityPending = Array.from(form.querySelectorAll('.cart-item__quantity-input')).some(function (i) { return i.value !== i.dataset.initialValue; });
      if (form.classList.contains('cart-form--refreshing') || form.querySelector('.merge-item-refreshing') || quantityPending) {
        this.say('Poczekaj chwilę na przeliczenie koszyka i spróbuj ponownie.', true); return;
      }
      busy = true; form.classList.add('sld-busy'); this.setAttribute('aria-busy', 'true');
      this.say(removing ? 'Usuwam kod…' : 'Sprawdzam kod…');
      var sectionId = this.dataset.sectionId;
      var attempted = false;
      var changed = false;
      try {
        var before = await api('cart.js');
        var prior = codes(before).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        if (!removing && prior.some(function (c) { return normal(c) === normal(code); })) {
          this.say('Ten kod jest już zastosowany.'); return;
        }
        var desired = removing ? prior.filter(function (c) { return normal(c) !== normal(code); }) : prior.concat(code);
        var update = function (values) { return api('cart/update.js', { discount: values.join(','), sections: [sectionId], sections_url: window.location.pathname }); };
        attempted = true;
        var cart = await update(desired);
        var accepted = codes(cart).filter(function (d) { return d.applicable; }).map(function (d) { return normal(d.code); });
        var invalid = !removing && !accepted.includes(normal(code));
        var conflict = !removing && prior.some(function (c) { return !accepted.includes(normal(c)); });
        // Invalid codes must not linger and silently apply after a later cart edit.
        if (invalid || conflict) cart = await update(prior);
        await merge(cart, form, sectionId); changed = true;
        var ui = current(form);
        if (!ui) return;
        if (invalid || conflict) {
          ui.input.value = code; ui.input.setAttribute('aria-invalid', 'true');
          ui.say(conflict ? 'Tego kodu nie można połączyć z obecnym rabatem. Usuń obecny kod i spróbuj ponownie.' : 'Kod jest nieprawidłowy lub nie spełniasz warunków promocji.', true);
          ui.focusInput();
        } else {
          var amount = applications(cart).filter(function (a) { return a.app.type === 'discount_code' && normal(a.app.title) === normal(code); }).reduce(function (sum, a) { return sum + Number(a.amount || 0); }, 0);
          ui.say(removing ? 'Kod został usunięty.' : (amount > 0 ? 'Rabat naliczony. Wartość produktów została przeliczona.' : 'Kod przyjęty. Nie obniża wartości produktów; warunki rabatu na dostawę zostaną sprawdzone po wyborze dostawy.'));
          var focus = removing ? ui.input : ui.querySelector('[data-sld-remove]');
          if (focus) focus.focus({ preventScroll: true });
        }
      } catch (error) {
        // A timed-out POST may still have succeeded. Reconcile before permitting checkout.
        if (attempted && !changed) {
          try { await merge(await api('cart.js'), form, sectionId); }
          catch (_) { form.setAttribute('data-sld-uncertain', 'true'); }
        }
        var ui = current(form);
        if (ui) {
          ui.input.value = code;
          ui.say('Nie udało się potwierdzić zmiany. Sprawdź połączenie i odśwież koszyk.', true);
          ui.querySelector('[data-sld-retry]').hidden = false;
        }
      } finally {
        busy = false; form.classList.remove('sld-busy');
        var ui = current(form); if (ui) ui.removeAttribute('aria-busy');
      }
    }
  }
  // Do not let quantity changes or checkout race with discount validation.
  document.addEventListener('click', function (e) {
    var form = e.target.closest('cart-form');
    if (!form) return;
    if (busy || (form.hasAttribute('data-sld-uncertain') && e.target.closest('.checkout-buttons'))) {
      e.preventDefault(); e.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('cart-form');
    if (form && (busy || form.hasAttribute('data-sld-uncertain'))) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (busy && e.target.matches('cart-form .cart-item__quantity-input')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('change', function (e) {
    if (busy && e.target.matches('cart-form .cart-item__quantity-input')) {
      e.target.value = e.target.dataset.initialValue; e.stopImmediatePropagation();
    }
  }, true);
  customElements.define('sl-cart-discount', SLCartDiscount);
})();
